import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { getEntityIdUrlSearch } from '../chartsUtils';
import { EntityType } from '../../entity.types';
import { getPageName } from '../../../utils/pageName';
import { openNewTab } from '../../../utils/domUtils';

export const villebaseH = 60;

export function buildCityUrl({
  entityName,
  ville,
  entityType,
  entityIdUrlArg,
}: {
  ville: string;
  entityName: string;
  entityIdUrlArg: string;
  entityType: EntityType;
}) {
  return buildUrlWithParameters('/search', {
    q: encodeURIComponent(entityName),
    ville: encodeURIComponent(`["${ville}"]`),
    [getEntityIdUrlSearch(entityType)]: entityIdUrlArg,
    chrono: true,
    sourcePage: getPageName(),
  });
}

export function villeClicked({
  ville,
  entityName,
  entityIdUrlArg,
  entityType,
  metaKey,
}: {
  ville: string;
  entityName: string;
  entityIdUrlArg: string;
  entityType: EntityType;
  metaKey: boolean;
}) {
  const url = buildCityUrl({ ville, entityName, entityIdUrlArg, entityType });
  if (metaKey) {
    openNewTab(url);
  } else {
    window.location.href = url;
  }
}
